module.exports = __webpack_public_path__ + "static/media/Nokia 220 Yellow.dd849b9a.png";